class ScrollFade extends HTMLElement {
  connectedCallback() {
    this.target = this.querySelector('[data-scroll-fade-target]') || this.firstElementChild;
    if (!this.target) return;

    this.update = this.update.bind(this);
    this.onWheel = this.onWheel.bind(this);

    this.target.addEventListener('scroll', this.update, { passive: true });
    this.target.addEventListener('wheel', this.onWheel, { passive: false });

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.target);
    }

    this.update();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  onWheel(event) {
    const max = this.target.scrollWidth - this.target.clientWidth;
    if (max <= 0 || Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
    event.preventDefault();
    this.target.scrollBy({ left: event.deltaY });
  }

  update() {
    const max = this.target.scrollWidth - this.target.clientWidth;
    if (max <= 0) {
      this.removeAttribute('data-fade-left');
      this.removeAttribute('data-fade-right');
      return;
    }
    this.toggleAttribute('data-fade-left', this.target.scrollLeft > 0);
    this.toggleAttribute('data-fade-right', this.target.scrollLeft < max - 1);
  }
}

customElements.define('scroll-fade', ScrollFade);
